module.exports = __webpack_public_path__ + "static/assets/64b87569fd76ebb7b1d67216c9163aca.png";